var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTokenPocket = function SvgTokenPocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4319_127796)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4319_127796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H11C4.92487 0 0 4.92487 0 11V21C0 27.0751 4.92487 32 11 32H21C27.0751 32 32 27.0751 32 21V11C32 4.92487 27.0751 0 21 0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4319_127796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5475 0H-0.84375V32H32.5475V0Z",
    fill: "#2980FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7124 13.7077H12.7165C12.7124 13.6831 12.7124 13.6544 12.7124 13.6299V13.7077Z",
    fill: "#29AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8626 14.4854H16.3515V22.6273C16.3515 23.0121 16.6626 23.3232 17.0474 23.3232H20.1667C20.5515 23.3232 20.8626 23.0121 20.8626 22.6273V14.4854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1738 8.65625H14.0224H5.94591C5.56109 8.65625 5.25 8.96734 5.25 9.35216V12.1767C5.25 12.5615 5.56109 12.8726 5.94591 12.8726H7.84119H8.59441V13.7076V22.6478C8.59441 23.0327 8.9055 23.3438 9.29028 23.3438H12.254C12.6388 23.3438 12.9499 23.0327 12.9499 22.6478V13.7076V13.6299V12.8726H13.7031H14.0101H14.1616C15.3241 12.8726 16.2697 11.927 16.2697 10.7644C16.282 9.60184 15.3364 8.65625 14.1738 8.65625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8667 14.4854V20.1671C21.0223 20.204 21.1819 20.2326 21.3457 20.2572C21.5749 20.2899 21.8123 20.3104 22.0497 20.3145C22.062 20.3145 22.0743 20.3145 22.0907 20.3145V15.7953C21.4071 15.7502 20.8667 15.1812 20.8667 14.4854Z",
    fill: "url(#paint0_linear_4319_127796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1807 8.65625C18.9632 8.65625 16.3515 11.2679 16.3515 14.4854C16.3515 17.2526 18.2796 19.5695 20.8667 20.1672V14.4854C20.8667 13.7608 21.4561 13.1714 22.1807 13.1714C22.9052 13.1714 23.4947 13.7608 23.4947 14.4854C23.4947 15.0953 23.0813 15.607 22.5163 15.7544C22.4099 15.783 22.2953 15.7994 22.1807 15.7994V20.3146C22.2953 20.3146 22.4058 20.3105 22.5163 20.3064C25.5783 20.1303 28.0098 17.5924 28.0098 14.4854C28.0139 11.2679 25.4023 8.65625 22.1807 8.65625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1806 20.3147V15.7995C22.1479 15.7995 22.1193 15.7995 22.0865 15.7954V20.3147C22.1193 20.3147 22.152 20.3147 22.1806 20.3147Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4319_127796",
    x1: 22.1826,
    y1: 17.4008,
    x2: 20.8673,
    y2: 17.4008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9667,
    stopColor: "white",
    stopOpacity: 0.3233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4319_127796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgTokenPocket as ReactComponent };
export default __webpack_public_path__ + "822cc5642f1ff95f6a60cf7c4a391a96.svg";